module.exports = __webpack_public_path__ + "img/illustration_popsicles.5fc10973.png";